"use client";

import { Image } from "@pamperedchef/design-system";
import type { CmsImage } from "@/composites/landing/types";
import * as styles from "./ImageCollage.module.scss";

export interface ImageCollageProps {
	images: CmsImage[];
}

/**
 * Editorial 5-image collage matching the SocialProof Figma layout. On desktop
 * a tall feature image fills the left column, with two stacked images in the
 * middle column and two in the right column whose split point is staggered. On
 * mobile every image stacks full-width. Placement is positional (see the SCSS
 * `:nth-child` rules), so authoring order is feature, middle-top, middle-bottom,
 * right-top, right-bottom. Presentational, props-in.
 */
export function ImageCollage({ images }: ImageCollageProps) {
	if (!images.length) return null;

	return (
		<div className={styles["image-collage"]} data-component="ImageCollage">
			{images.map((image, i) => (
				<figure
					key={`${image.url}-${i}`}
					className={styles["image-collage__item"]}
				>
					<Image
						src={image.url}
						alt={image.alt ?? ""}
						className={styles["image-collage__image"]}
						objectFit="cover"
					/>
				</figure>
			))}
		</div>
	);
}
